import React from 'react';
import { Card } from '../ui/Card';
import { Button } from '../ui/Button';
import { PlusIcon, UsersIcon } from 'lucide-react';
export function Instructors() {
  return <div className="space-y-6" data-id="element-1755">
      <div className="flex justify-between items-center" data-id="element-1756">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-1757">Instructors</h1>
        <Button variant="primary" size="sm" data-id="element-1758">
          <PlusIcon className="h-4 w-4 mr-2" data-id="element-1759" />
          Add Instructor
        </Button>
      </div>
      <Card data-id="element-1760">
        <div className="flex flex-col items-center justify-center h-64 border border-dashed border-gray-300 rounded-md" data-id="element-1761">
          <UsersIcon className="h-12 w-12 text-gray-400" data-id="element-1762" />
          <p className="mt-2 text-gray-500" data-id="element-1763">No instructors found</p>
          <Button variant="outline" size="sm" className="mt-4" data-id="element-1764">
            <PlusIcon className="h-4 w-4 mr-2" data-id="element-1765" />
            Add Instructor
          </Button>
        </div>
      </Card>
    </div>;
}